export function getDepositLoading(state) {
    return state.DepositReducer.isLoading;
}

export function getDeposits(state) {
    return state.DepositReducer.deposits;
}